/**
 * 事業部モジュールの登録簿。
 *
 * 全社PLはここから各事業部のモジュールを取得し、`getMonthlySummary()` の
 * **5行を単純合算するだけ**で構成する。事業部固有の項目は全社側に持ち込まない。
 *
 * 事業部セッションが `/modules/<事業部名>/` に自前の実装を作ったら、
 * ここに1行足すだけで全社PLに反映される(全社PL側の変更は不要)。
 */
import { createGenericDepartmentModule, getPendingSummary } from './genericDepartmentModule';
import { createHonbuModule, getHonbuPendingSummary, HONBU_DEPARTMENT_ID } from '@modules/honbu';
import type {
  Account,
  DepartmentId,
  DepartmentModule,
  MonthStr,
  SummaryLine,
} from '@core/lib/types';

export function getDepartmentModule(
  departmentId: DepartmentId,
  accounts: Account[],
): DepartmentModule {
  switch (departmentId) {
    case HONBU_DEPARTMENT_ID:
      return createHonbuModule(accounts);
    // フェーズ3以降、各事業部の実装ができ次第ここに追加する
    //   case 'unso': return createUnsoModule(accounts);
    default:
      return createGenericDepartmentModule(departmentId, accounts);
  }
}

/** 見込み(承認済・提出済)。実績とは別に扱う */
export function getDepartmentPendingSummary(
  departmentId: DepartmentId,
  month: MonthStr,
  accounts: Account[],
): Promise<SummaryLine> {
  if (departmentId === HONBU_DEPARTMENT_ID) {
    return getHonbuPendingSummary(month, accounts);
  }
  return getPendingSummary(departmentId, month, accounts);
}
